<ion-col class="access-point-container">
  <span class="header-text">{{ header }}</span>
  <ion-card class="card-container" [disabled]="disable">
    <!-- Header -->
    <ion-card-title class="header">
      <ion-row class="search-wrapper">
        <ion-col size="11">
          <ion-input
            class="input-container"
            fill="outline"
            [disabled]="disable"
            [placeholder]="searchPlaceholder"
            [(ngModel)]="searchValue"
            (ngModelChange)="search($event)"
          >
          </ion-input>
          <div
            class="clear-search-text-icons"
            onkeypress="clearSearch()"
            (click)="clearSearch()"
          >
            <img
              alt="cancel"
              [src]="showAltSearch ? IMAGES.CLEAR : IMAGES.SEARCH"
              [ngClass]="{ 'active-click': showAltSearch }"
            />
          </div>
        </ion-col>
      </ion-row>
    </ion-card-title>
    <!------------>

    <!-- Body -->
    <ion-card-content class="card-content">
      <ion-list>
        <ion-item lines="none" class="item" (click)="onAllSelect()">
          <ion-checkbox
            slot="start"
            labelPlacement="end"
            justify="start"
            class="checkbox"
            [(ngModel)]="allSelected"
          >
            {{ SELECT_TEXT }}
          </ion-checkbox>
        </ion-item>
        @for (item of displayedData; track item; let i = $index) {
          <ion-item lines="none" class="item" (click)="onCheckboxChanges()">
            <ion-checkbox
              slot="start"
              labelPlacement="end"
              justify="start"
              class="checkbox"
              [(ngModel)]="item.selected"
            >
              {{ isGroupForm ? item.data.code : item.data.name }}
            </ion-checkbox>
          </ion-item>
        }
      </ion-list>
    </ion-card-content>
    <!---------->

    <!-- Footer -->
    <ion-row class="footer-row">
      <ion-button
        class="button"
        [disabled]="isButtonDisabled"
        [ngClass]="{ disabled: isButtonDisabled }"
        (click)="onAssignUnassignClick()"
      >
        <ion-icon slot="start" [src]="iconName" color="light"></ion-icon>
        {{ buttonText }}
      </ion-button>
    </ion-row>
    <!------------>
  </ion-card>
</ion-col>
